<template>
  <symbol
    id="star-half"
    viewBox="0 0 16 16"
  >
    <path
      d="M10.054 5.53737L7.88358 0L5.79481 5.53824L0 6.01731L4.30885 10.0224L2.92126 15.8106L7.88475 12.7692L12.8663 16L11.5217 10.0293L16 6.01759L10.054 5.53737ZM7.89869 2.42626L9.43931 6.35678L13.9166 6.71745L10.5603 9.72651L11.5478 14.1111L7.89807 11.7448L7.89869 2.42626Z"
    />
  </symbol>
</template>
